<template>
  <VRow justify="center">
    <VCol
      class="px-2 pb-6 d-flex align-center pt-0"
      cols="12"
    >
      <div>
        <span class="body-1">
          {{ $t('authForm.phoneNumber') }}
        </span>
      </div>
      <div class="ml-2">
        <span class="body-bold">
          {{ phone }}
        </span>
      </div>
      <div class="ml-2">
        <VBtn
          small
          class="box-shadow-elevation-4"
          @click="$emit('toStartStep')"
        >
          <span class="small-button">
            {{ $t('general.edit') }}
          </span>
        </VBtn>
      </div>
    </VCol>
    <VCol
      class="px-2 pb-3 pt-0"
      cols="12"
    >
      <span class="body-2">{{ $t('authForm.tooManyAttempts') }}</span>
    </VCol>
    <VCol
      class="px-2 pb-2 pt-0"
      cols="12"
    >
      <span class="body-2">{{ $t('authForm.safetyMeasures') }}</span>
    </VCol>
    <VCardActions class="px-2 pb-2 pt-5 d-flex justify-content-center">
      <div class="px-1 w-100 d-flex justify-content-center">
        <VBtn
          class="w-100 brandingPrimary--text header__link"
          color="brandingPrimary--text"
          :active="false"
          exact
          outlined
          :to="{ name: 'ContactUs' }"
        >
          <span class="button brandingPrimary--text">
            {{ $t('authForm.contactUs') }}
          </span>
        </VBtn>
      </div>
    </VCardActions>
  </VRow>
</template>
<script lang="ts">
export default {
  name: 'BlockedAuth',
};
</script>

<script setup lang="ts">
defineProps({
  phone: {
    type: String,
    default: '',
  },
});
</script>
<style lang="scss" scoped>
@import "@slg/web-customer-shared/src/style/headerLinks.scss";
</style>
